import React from "react";
import { TextField, TextFieldProps } from "components/TextField";

export type MultilineTextFieldProps = TextFieldProps;

/**
 * A Multiline Text Field, based on MUI TextField
 * @param minRows The minimum number of rows the text field should display, defaults to 2
 * @param maxRows The maximum number of rows the text field should display, defaults to 5
 * @param textFieldProps any other properties that MUI TextField can use
 */
export const MultilineTextField = ({
  minRows = 2,
  maxRows = 5,
  ...textFieldProps
}: MultilineTextFieldProps): JSX.Element => {
  return (
    <TextField
      multiline
      minRows={minRows}
      maxRows={maxRows}
      {...textFieldProps}
    />
  );
};
